import { dropdownMenuRender } from './components/dropdown_menu';
import { setUserCookieIfAgent } from './components/set_user_agent_cookie/';

export const initHeaderBundle = () => {
  (window as any).renderHeaderDropdown = dropdownMenuRender;
  (window as any).setUserCookieIfAgent = setUserCookieIfAgent;
};



// WEBPACK FOOTER //
// ./src/bundles/header/index.tsx